export const OVERALL_PROFORMA_INVOICE_STATUS_LABELS = {
  CREATED: 'CREATED',
  DRAFT: 'DRAFT',
};

export const OVERALL_PROFORMA_INVOICE_STATUS_COLORS = {
  CREATED: 'success',
  DRAFT: 'info',
};
